module.exports = __webpack_public_path__ + "static/media/logo.65322e1a.svg";